var map = {
	"./ArrowLineRight.svg": 18262,
	"./Bitmap.svg": 82286,
	"./Commercial.svg": 49269,
	"./CommercialIcon.svg": 52034,
	"./Ellipse 285.svg": 13720,
	"./PropertyPriceLastSoldValuation.svg": 17558,
	"./Residential.svg": 76739,
	"./Vector.svg": 5274,
	"./a-payment-white.svg": 49861,
	"./a-payment.svg": 12081,
	"./accept-estimate-icon.svg": 92532,
	"./account-active.svg": 74915,
	"./account-circle.svg": 77197,
	"./account-details-dark-icon.svg": 50576,
	"./account-icon.svg": 21938,
	"./account-inactive.svg": 95914,
	"./account-progress-bar.svg": 98752,
	"./account-starter-progress.svg": 72206,
	"./account-step-check.svg": 32448,
	"./account-step-complete-job.svg": 18515,
	"./account-step-post.svg": 50638,
	"./account-step-setup.svg": 93535,
	"./account-type-icon.svg": 78417,
	"./account.svg": 12064,
	"./active-projects.svg": 40456,
	"./add-avatar-icon.svg": 16300,
	"./add-button-icon-yellow.svg": 46006,
	"./add-button-icon.svg": 44769,
	"./add-circle-yellow.svg": 37042,
	"./add-icon-blue-2.svg": 24310,
	"./add-icon-blue.svg": 83715,
	"./add-logo.svg": 496,
	"./add-new-skill.svg": 97069,
	"./add-note-icon.svg": 48673,
	"./add-person.svg": 15854,
	"./add-profile.svg": 51360,
	"./add-project-filled-icon.svg": 72965,
	"./add-workspace.svg": 89236,
	"./add.svg": 71480,
	"./alert-box-red.svg": 81793,
	"./all-jobs-filter.svg": 32560,
	"./analytics-estimate.svg": 88880,
	"./analyticsCustomerRating.svg": 18710,
	"./analyticsEstimateSent.svg": 36773,
	"./analyticsJobsCompleted.svg": 10928,
	"./architecture-icon.svg": 15084,
	"./archive-icon.svg": 35895,
	"./arrow-collapse.svg": 6746,
	"./arrow-down-icon.svg": 36531,
	"./arrow-expand-more.svg": 53863,
	"./arrow-left.svg": 65648,
	"./arrow-right-yellow.svg": 46384,
	"./arrow-right.svg": 76415,
	"./arrow-up-icon.svg": 39954,
	"./assign-member-icon.svg": 17755,
	"./attach-pin.svg": 38010,
	"./audit-icon.svg": 18534,
	"./available.svg": 16588,
	"./avatar-blue.svg": 63425,
	"./avatar-tp-icon.svg": 43165,
	"./awaiting-estimates-icon.svg": 12223,
	"./back.svg": 79082,
	"./background-wave.svg": 96471,
	"./bath-icon.svg": 52678,
	"./bed-icon.svg": 83490,
	"./bell-icon.svg": 30414,
	"./big-trash-icon.svg": 25992,
	"./bike-ride-filled-icon.svg": 49654,
	"./billing-icon.svg": 73618,
	"./blue-check.svg": 16764,
	"./blue-edit.svg": 50512,
	"./blue-exclaimation.svg": 96136,
	"./blue-money-out.svg": 35571,
	"./blue-triangle.svg": 77200,
	"./building-filled-icon.svg": 28942,
	"./buildings-filled-icon.svg": 87395,
	"./burger-menu.svg": 30220,
	"./c-payment.svg": 60351,
	"./calendar-2.svg": 10560,
	"./calendar-delete-modal.svg": 91299,
	"./calendar-delete.svg": 77351,
	"./calendar-icon.svg": 85357,
	"./calendar-instructions.svg": 37541,
	"./calendar-modal-edit.svg": 59386,
	"./calendar-modal-icon.svg": 71789,
	"./calu-pen.svg": 41248,
	"./camera.svg": 58854,
	"./camera2.svg": 23752,
	"./cancel-2.svg": 68620,
	"./cancel.svg": 92045,
	"./cancelled-icon.svg": 78610,
	"./categories-icon.svg": 93327,
	"./categories.svg": 70731,
	"./certificate-filled-icon.svg": 47941,
	"./certificate.svg": 62156,
	"./chat-dark.svg": 94822,
	"./chat-dox-white.svg": 92755,
	"./chat-dox.svg": 48435,
	"./chat-emoji-icon.svg": 68050,
	"./chat-empty.svg": 49593,
	"./chat-filter.svg": 79984,
	"./chat-icon.svg": 62401,
	"./chat-menu-icon.svg": 91191,
	"./chat-mic-icon.svg": 74367,
	"./chat-orange-send-icon.svg": 33551,
	"./chat-vid-icon.svg": 54923,
	"./chat.svg": 98701,
	"./check-blue.svg": 13190,
	"./check-mark-sucess.svg": 57848,
	"./check.svg": 82497,
	"./checked.svg": 49406,
	"./cheveron-left.svg": 41845,
	"./chevron-right.svg": 19501,
	"./circle.svg": 77183,
	"./circular-edit-pen-filled-blue.svg": 13053,
	"./clip-icon.svg": 18241,
	"./clock-2.svg": 5806,
	"./clock-3.svg": 36799,
	"./clock-icon.svg": 51663,
	"./clock.svg": 92075,
	"./clock_circle.svg": 37374,
	"./close-2.svg": 51452,
	"./collaboration-icon.svg": 45288,
	"./comment.svg": 29886,
	"./commercial-filter.svg": 5208,
	"./commerical.svg": 13725,
	"./company.svg": 92024,
	"./complete-1.svg": 3560,
	"./complete-project.svg": 15070,
	"./complete-projects.svg": 44001,
	"./complete.svg": 94618,
	"./completed-filter.svg": 35273,
	"./completed-icon.svg": 46932,
	"./confirm-accept-job.svg": 75644,
	"./confirm-accept-quote.svg": 67173,
	"./confirm-estimate-icon.svg": 57270,
	"./confirm-reject-quote.svg": 55648,
	"./congratulations.svg": 67200,
	"./connections-icon.svg": 42832,
	"./connections.svg": 96486,
	"./construction.svg": 37632,
	"./copy-2.svg": 96037,
	"./copy-3.svg": 41316,
	"./copy.svg": 28552,
	"./couch-filled-icon.svg": 12542,
	"./courses-hero-image-2.svg": 69313,
	"./create-new-folder-icon.svg": 41539,
	"./create-plus.svg": 18228,
	"./create-task-icon.svg": 70703,
	"./cross-icon.svg": 11449,
	"./cursor.svg": 51849,
	"./curve-arrow.svg": 25796,
	"./custom-loader.svg": 28878,
	"./dark-filled-home-icon.svg": 18146,
	"./dashboard-menu-icon.svg": 53839,
	"./dashboard-no-chat.svg": 60114,
	"./dashboard-no-mentions.svg": 19489,
	"./dashboard-no-projects.svg": 18974,
	"./dashboard-no-transactions.svg": 55019,
	"./dashboard.svg": 17461,
	"./date-icon.svg": 46123,
	"./date.svg": 33463,
	"./day-rate.svg": 83658,
	"./deactivate-icon-2.svg": 26792,
	"./deactivate-icon.svg": 34721,
	"./decrement.svg": 13034,
	"./delete-icon-white.svg": 66876,
	"./delete-icon.svg": 2668,
	"./delete-solid.svg": 10352,
	"./delete-stage-icon.svg": 27143,
	"./delete.svg": 90930,
	"./description-calendar.svg": 45866,
	"./details-menu-icon.svg": 48933,
	"./distance.svg": 9626,
	"./document-icon.svg": 41274,
	"./document.svg": 152,
	"./documents.svg": 19243,
	"./done.svg": 56903,
	"./dots.svg": 48999,
	"./down-arrow.svg": 5743,
	"./download-icon.svg": 94971,
	"./download-yellow-filled-icon.svg": 79273,
	"./downloads.svg": 19382,
	"./draft-icon.svg": 3050,
	"./draft-project.svg": 20860,
	"./draft-projects.svg": 12631,
	"./drive-ways-icon.svg": 94636,
	"./driveways-and-paving.svg": 69245,
	"./driveways.svg": 29241,
	"./dual-message.svg": 19227,
	"./dudley-college-icon.svg": 80710,
	"./duration-filled-icon.svg": 14054,
	"./earnings-icon.svg": 5032,
	"./edit-chat-2.svg": 61003,
	"./edit-chat.svg": 90666,
	"./edit-pen-icon.svg": 31549,
	"./edit-pen-yellow-filled-icon.svg": 30623,
	"./electrical.svg": 4405,
	"./electricalChart copy.svg": 34278,
	"./electricalChart.svg": 18571,
	"./email-sent.svg": 49704,
	"./emergency-callout.svg": 87069,
	"./emergency-filter.svg": 89473,
	"./emergency-watch.svg": 41356,
	"./emoji.svg": 37795,
	"./empty-accreditations-icon.svg": 72388,
	"./empty-calendar-icon.svg": 48705,
	"./empty-description-icon.svg": 23287,
	"./empty-expertise-icon.svg": 21582,
	"./empty-files-folder-icon.svg": 19621,
	"./empty-gallery-icon.svg": 78571,
	"./empty-insurance-icon.svg": 98777,
	"./empty-notif.svg": 98087,
	"./empty-project-icon.svg": 40196,
	"./empty-templates-icon.svg": 37002,
	"./empty-transaction-list.svg": 60834,
	"./empty-workstation.svg": 26636,
	"./energy.svg": 64539,
	"./escrow-wallet-icon.svg": 63762,
	"./estimate-icon.svg": 73117,
	"./estimate-loader.svg": 40007,
	"./estimate-sent-filter.svg": 17963,
	"./estimate-tab.svg": 44379,
	"./estimate.svg": 10009,
	"./estimates-receive-icon.svg": 76502,
	"./estimates-received.svg": 71424,
	"./estimates-sent-icon.svg": 76135,
	"./exclaimation-icon.svg": 36827,
	"./exclaimation-mark.svg": 48539,
	"./exclaimation.svg": 20647,
	"./external_contractor.svg": 39324,
	"./face.svg": 55176,
	"./file-upload-icon.svg": 29925,
	"./file-upload.svg": 65713,
	"./filled-blue-folder-icon.svg": 58745,
	"./filled-calendar-icon.svg": 78316,
	"./filled-details-icon.svg": 52172,
	"./filled-download-icon.svg": 34882,
	"./filled-edit-icon.svg": 65110,
	"./filled-gray-folder-icon.svg": 40924,
	"./filled-image-icon.svg": 34699,
	"./filled-move-icon.svg": 75547,
	"./filled-share-icon.svg": 37581,
	"./filled-sort-icon.svg": 29086,
	"./filter-icon-2.svg": 73716,
	"./filter-icon.svg": 92069,
	"./filter.svg": 87985,
	"./finance-icon.svg": 72207,
	"./finance.svg": 98475,
	"./floors.svg": 7906,
	"./folder-yellow-icon.svg": 16598,
	"./folder.svg": 30811,
	"./footer-menu-chat-icon.svg": 39249,
	"./footer-menu-chat.svg": 87037,
	"./footer-menu-dashboard-icon.svg": 53769,
	"./footer-menu-find-icon.svg": 54948,
	"./footer-menu-find-jobs.svg": 51523,
	"./footer-menu-hamburger.svg": 18764,
	"./footer-menu-home.svg": 52526,
	"./footer-menu-project.svg": 30198,
	"./footer-menu-projects-icon.svg": 33165,
	"./footer-menu-quotes.svg": 95256,
	"./footer-menu-search.svg": 78567,
	"./footer-menu-workspace.svg": 67566,
	"./free-member-bg-white.svg": 70696,
	"./free-member-blue.svg": 9441,
	"./g-payment.svg": 15667,
	"./gallery.svg": 61691,
	"./gas-icon.svg": 54100,
	"./gas.svg": 22506,
	"./gasChart.svg": 72446,
	"./gbp-currency.svg": 28940,
	"./graduation-hat.svg": 38935,
	"./green-check.svg": 20083,
	"./green-double-tick.svg": 30148,
	"./green-star-circle.svg": 56886,
	"./group-chat-icon.svg": 33647,
	"./hand-icon-check.svg": 29981,
	"./handyman-services.svg": 32012,
	"./heart-icon.svg": 56233,
	"./heart.svg": 49733,
	"./heating.svg": 66835,
	"./hide-icon.svg": 49991,
	"./historic_project_icon.svg": 71974,
	"./home-filled-icon-2.svg": 38410,
	"./home-filled-icon.svg": 92079,
	"./home-icon.svg": 56,
	"./home-yellow-filled-icon.svg": 69238,
	"./home.svg": 74174,
	"./hourly-rate.svg": 10491,
	"./house-bg-icon.svg": 99127,
	"./house-icon.svg": 78457,
	"./house.svg": 58901,
	"./houses.svg": 16060,
	"./id-check.svg": 97383,
	"./id-not-verified.svg": 17101,
	"./idea-icon.svg": 48860,
	"./iknowa-initials-logo.svg": 2356,
	"./iknowa-invoice-logo.svg": 95380,
	"./iknowa-logo-2.svg": 5099,
	"./iknowa-logo.svg": 91594,
	"./image-attachment.svg": 27220,
	"./image-file-icon.svg": 58073,
	"./image-icon.svg": 11500,
	"./image_placeholder.svg": 38456,
	"./imagefile-icon.svg": 21730,
	"./in-progress-filter.svg": 14729,
	"./in-progress-icon.svg": 39828,
	"./in-progress-setting.svg": 64301,
	"./in-progress-white.svg": 90950,
	"./in-progress.svg": 64842,
	"./incomplete.svg": 74371,
	"./increment.svg": 31374,
	"./info-alert.svg": 90038,
	"./info-black.svg": 89389,
	"./info-grey.svg": 49301,
	"./info-icon-transparent.svg": 39070,
	"./info-icon.svg": 96999,
	"./info-orange.svg": 55570,
	"./info-outline.svg": 36534,
	"./info.svg": 36947,
	"./insulation.svg": 3993,
	"./insulationChart.svg": 15839,
	"./insurance-file-icon.svg": 48502,
	"./insurance-icon.svg": 88733,
	"./insurance.svg": 43961,
	"./intercom.svg": 30250,
	"./interest-card-confirmation-icon.svg": 75668,
	"./interest-card-thanyou-icon.svg": 69465,
	"./invite-icon.svg": 11630,
	"./invite-sent-member.svg": 20182,
	"./invite.svg": 90764,
	"./invites-pending-icon.svg": 76909,
	"./invoice.svg": 98292,
	"./issue-raise.svg": 55167,
	"./job-client-empty-icon.svg": 77926,
	"./jobService.svg": 14713,
	"./key-filled-icon.svg": 47609,
	"./krystal-blue.svg": 59220,
	"./krystal-icon.svg": 63795,
	"./krystal.svg": 10479,
	"./kyp-icon.svg": 24785,
	"./kyp-icons/air-source-icon.svg": 33869,
	"./kyp-icons/boundery-icon.svg": 57453,
	"./kyp-icons/devices-icon.svg": 93338,
	"./kyp-icons/epc-icon.svg": 39887,
	"./kyp-icons/floor-plan-icon.svg": 79229,
	"./kyp-icons/fuse-box-icon.svg": 68594,
	"./kyp-icons/insurance-icon-2.svg": 85224,
	"./kyp-icons/living-room-icon.svg": 49474,
	"./kyp-icons/planning-icon.svg": 7982,
	"./kyp-icons/propertree-icon.svg": 2141,
	"./kyp-icons/score-icon.svg": 26491,
	"./kyp-icons/solar-pv-icon.svg": 50857,
	"./kyp-icons/title-deeds-icon.svg": 26297,
	"./kyp-icons/valuation-icon.svg": 54570,
	"./leave-estimate-icon.svg": 23527,
	"./leave-page-icon.svg": 22114,
	"./left-chevron.svg": 71786,
	"./lens.svg": 48091,
	"./lighting.svg": 63719,
	"./lines.svg": 1496,
	"./list-and-pen.svg": 17493,
	"./list-view-dark-icon.svg": 12922,
	"./load-icon.svg": 20587,
	"./load-template-icon.svg": 57056,
	"./location-filled-icon.svg": 47687,
	"./lock.svg": 45482,
	"./lockicon.svg": 42761,
	"./logout.svg": 34277,
	"./manage-documents-filled-icon.svg": 51978,
	"./map-marker.svg": 86054,
	"./map-view-dark-icon.svg": 63114,
	"./map.svg": 59543,
	"./market-history-icon.svg": 81538,
	"./master-card-icon.svg": 59214,
	"./measure.svg": 27633,
	"./members-icon.svg": 42582,
	"./mention.svg": 83395,
	"./menu-close.svg": 38333,
	"./menu.svg": 72434,
	"./message-chat.svg": 18987,
	"./message-icon.svg": 70170,
	"./messages-add-video-icon.svg": 79923,
	"./messages-files-icon.svg": 89685,
	"./messages-icon.svg": 61775,
	"./messages-white.svg": 92539,
	"./messages.svg": 11979,
	"./meter.svg": 72690,
	"./mic-filled-icon.svg": 3893,
	"./microphone-2.svg": 11522,
	"./microphone.svg": 26007,
	"./model_training_black.svg": 79579,
	"./money-card.svg": 45392,
	"./more-dots.svg": 97677,
	"./more-icon.svg": 4646,
	"./move-left.svg": 17818,
	"./move-right.svg": 13265,
	"./my-document.svg": 34657,
	"./my-project.svg": 42989,
	"./network-icon.svg": 75263,
	"./new-chat-close-icon.svg": 40433,
	"./new-icon.svg": 44155,
	"./new-sort-icon.svg": 95614,
	"./news.svg": 8566,
	"./no-attachments-icon.svg": 43043,
	"./no-document-icon.svg": 33498,
	"./no-members-icon.svg": 40182,
	"./not-added.svg": 95747,
	"./not-started-filter.svg": 98493,
	"./not-started-icon.svg": 50552,
	"./not-started.svg": 82558,
	"./not-verified-icon.svg": 17399,
	"./note-pen.svg": 66421,
	"./notepad.svg": 41034,
	"./notification-bell.svg": 3096,
	"./notification-status-dot.svg": 77383,
	"./notifications-icon.svg": 68317,
	"./opportunities-icon.svg": 90412,
	"./orange-calendar.svg": 52368,
	"./pad-pen.svg": 11716,
	"./painting.svg": 80331,
	"./pause.svg": 51947,
	"./payment-notification-icon.svg": 36905,
	"./payment-success.svg": 33465,
	"./pdf-document-icon.svg": 51131,
	"./pdf-icon-sample.svg": 98654,
	"./pdf-icon.svg": 57447,
	"./pdficon.svg": 94676,
	"./pen-filled-icon.svg": 50349,
	"./pen-filled-yellow-icon.svg": 38776,
	"./pencil-circle-blue.svg": 418,
	"./pending-icon-dark.svg": 82555,
	"./pending-icon.svg": 15994,
	"./pending.svg": 87352,
	"./personal-calendar-2.svg": 67527,
	"./personal-calendar.svg": 82126,
	"./phone-filled-icon.svg": 60356,
	"./photo-placeholder.svg": 26945,
	"./pie-with-circle.svg": 93385,
	"./pin-location-blue.svg": 88513,
	"./pin-location.svg": 30032,
	"./plus-circle.svg": 68648,
	"./popup-calender-calender.svg": 893,
	"./popup-calender-clock.svg": 61323,
	"./post-project-2.svg": 30304,
	"./post-project-confirmation-icon.svg": 43277,
	"./post-project.svg": 73961,
	"./pound-circle.svg": 91072,
	"./preferred-contractors-empty.svg": 46397,
	"./prefix.svg": 83375,
	"./premium-bg-white.svg": 65334,
	"./premium-filter.svg": 62557,
	"./premium-plan.svg": 86438,
	"./profile-banner.svg": 20197,
	"./profile-no-content-icon.svg": 1248,
	"./profile-visit-icon.svg": 63686,
	"./project-banner-icon.svg": 62129,
	"./project-icon.svg": 15248,
	"./project-insurance-guard-icon.svg": 49881,
	"./project-logs-sidebar/calculator-and-pen.svg": 63530,
	"./project-logs-sidebar/list-and-pen.svg": 99834,
	"./project-notification-icon.svg": 33948,
	"./project-owner-active.svg": 12399,
	"./project-owner-inactive.svg": 60222,
	"./project-post.svg": 24437,
	"./project-progress-bar.svg": 14618,
	"./project-status.svg": 36106,
	"./project-thumbnail-icon.svg": 96761,
	"./projects-filled-icon.svg": 70980,
	"./promise-money-logo.svg": 20815,
	"./properties-add-property.svg": 94296,
	"./properties-icon.svg": 69130,
	"./properties-my-property.svg": 10835,
	"./properties-occupier.svg": 61011,
	"./properties-owner.svg": 95526,
	"./property-green.svg": 58366,
	"./property-insurance-icon.svg": 79299,
	"./property-lightgreen.svg": 50052,
	"./property-listing-bath.svg": 54379,
	"./property-listing-bed.svg": 47317,
	"./property-listing-calender.svg": 33142,
	"./property-listing-grid.svg": 35632,
	"./property-listing-location.svg": 79605,
	"./property-listing-sofa.svg": 2261,
	"./property-orange.svg": 78659,
	"./property-red.svg": 40990,
	"./property-white-green.svg": 25358,
	"./propety-data-tab/comparable-icon.svg": 5131,
	"./propety-data-tab/legal-icon.svg": 58141,
	"./propety-data-tab/market-history-icon.svg": 14473,
	"./propety-data-tab/members-icon.svg": 46771,
	"./propety-data-tab/my-document.svg": 85242,
	"./propety-data-tab/projects-filled-icon.svg": 56009,
	"./propety-data-tab/property-data-icon.svg": 53484,
	"./propety-data-tab/property-map-icon.svg": 68770,
	"./question-info.svg": 40720,
	"./quote-notification-icon.svg": 42639,
	"./quotes.svg": 70984,
	"./range-icon.svg": 44020,
	"./rating-star.svg": 52306,
	"./received-request.svg": 14498,
	"./recent-files-pdf-icon.svg": 89265,
	"./reception-icon.svg": 40064,
	"./recommendation-icons/home-rounded-square-yellow.svg": 96830,
	"./recommendation-icons/speedometer-rounded-square-violet.svg": 24145,
	"./recommendation-icons/tp-rounded-square-olive.svg": 44844,
	"./red-exclaimation.svg": 61109,
	"./refresh-2.svg": 88765,
	"./reject-estimate-icon.svg": 70825,
	"./rejected-filter.svg": 26767,
	"./rejected-icon.svg": 95357,
	"./rejected.svg": 25433,
	"./remove-black.svg": 43285,
	"./requests-icon.svg": 14849,
	"./requests.svg": 10829,
	"./residential-filter.svg": 56394,
	"./residentialIcon.svg": 53892,
	"./revenueOverview.svg": 67272,
	"./revenuePerformance.svg": 769,
	"./revenueService.svg": 14702,
	"./right-arrow.svg": 14263,
	"./right-chevron.svg": 79765,
	"./roof.svg": 36977,
	"./routine-filter.svg": 9216,
	"./sample-skill-icon.svg": 46469,
	"./save-draft-icon.svg": 80844,
	"./save.svg": 44660,
	"./schedule-icon.svg": 31298,
	"./search-icon.svg": 35691,
	"./search.svg": 64343,
	"./security-icon.svg": 47569,
	"./security-light-icon.svg": 45904,
	"./send-2.svg": 59704,
	"./send-invite-icon.svg": 87485,
	"./send-message.svg": 78683,
	"./send.svg": 46385,
	"./sent-request.svg": 26709,
	"./services-billing-icon.svg": 8425,
	"./services-icon.svg": 3239,
	"./services-members-icon.svg": 45337,
	"./services-projects-icon.svg": 68732,
	"./services-storage-icon.svg": 47475,
	"./services-transaction-icon.svg": 56198,
	"./settings.svg": 20716,
	"./shape.svg": 49582,
	"./share-icon.svg": 98934,
	"./sidebar-icons/analytics.svg": 43013,
	"./sidebar-icons/calendar.svg": 25337,
	"./sidebar-icons/chat.svg": 6045,
	"./sidebar-icons/client.svg": 25654,
	"./sidebar-icons/clock_circle.svg": 1038,
	"./sidebar-icons/connections.svg": 95638,
	"./sidebar-icons/courses.svg": 10919,
	"./sidebar-icons/dashboard.svg": 67109,
	"./sidebar-icons/documents.svg": 11675,
	"./sidebar-icons/eWallet.svg": 94419,
	"./sidebar-icons/issue.svg": 27828,
	"./sidebar-icons/jobs.svg": 5611,
	"./sidebar-icons/members.svg": 52596,
	"./sidebar-icons/menu.svg": 59970,
	"./sidebar-icons/projects.svg": 95305,
	"./sidebar-icons/property.svg": 82252,
	"./sidebar-icons/trade-passport.svg": 79070,
	"./sidebar-toggle-close.svg": 31822,
	"./sidebar-toggle-open.svg": 35651,
	"./single-chat-icon.svg": 69924,
	"./sitevisitemptystate.svg": 67869,
	"./skeleton-home-filled-icon.svg": 23187,
	"./solar-icon.svg": 65008,
	"./solar.svg": 82566,
	"./sole-trader-icon-light.svg": 31430,
	"./sort-asc.svg": 88051,
	"./sort-desc.svg": 1419,
	"./sort-icon.svg": 76699,
	"./sort-triangle.svg": 83092,
	"./sort.svg": 12871,
	"./specialism-house.svg": 91814,
	"./specialism-info.svg": 74062,
	"./specialism-krystal.svg": 39052,
	"./standard-filter.svg": 35279,
	"./star-icon.svg": 48243,
	"./status-emergency-icon.svg": 18717,
	"./status-emergency.svg": 33561,
	"./status-flexible-icon.svg": 85587,
	"./status-not-started.svg": 81261,
	"./status-out-of-hours.svg": 98342,
	"./status-routine-blue.svg": 88159,
	"./status-routine-icon.svg": 30408,
	"./status-schedule-icon.svg": 98033,
	"./status-standard-icon.svg": 24173,
	"./storage-icon.svg": 32944,
	"./submit-estimate-icon.svg": 59120,
	"./submitting-estimate.svg": 75406,
	"./subscription-icon.svg": 48386,
	"./subscription-light-icon.svg": 39455,
	"./team-performance-empty-screen.svg": 91422,
	"./teamPerformance.svg": 47682,
	"./template-icon-2.svg": 75280,
	"./template-icon.svg": 92185,
	"./tick-circle.svg": 78181,
	"./tick.svg": 16920,
	"./tile-view-dark-icon.svg": 84570,
	"./timeline-icon.svg": 91352,
	"./toggle-mobile-close-fullview.svg": 23614,
	"./toggle-mobile-open-fullview.svg": 56880,
	"./tools-bag-icon.svg": 95385,
	"./tools-bg-icon.svg": 31626,
	"./tools-icon.svg": 57826,
	"./tools.svg": 46448,
	"./tooltip.svg": 93356,
	"./tp-icon.svg": 88251,
	"./trade-network-currency.svg": 70910,
	"./trade-network-list.svg": 10095,
	"./trade-network-location.svg": 47758,
	"./trade-network-prize.svg": 40993,
	"./trade-network-right-left-arrow.svg": 66011,
	"./trade-network-search.svg": 68335,
	"./trade-network-sort.svg": 26303,
	"./trade-network-trader.svg": 16535,
	"./tradesperson-active.svg": 46256,
	"./tradesperson-inactive.svg": 22921,
	"./transaction-icon-1.svg": 43739,
	"./transaction-icon-2.svg": 62376,
	"./transaction-icon-3.svg": 27769,
	"./transaction-successful.svg": 5588,
	"./trash-filled.svg": 24836,
	"./trash-icon.svg": 44927,
	"./trash.svg": 36891,
	"./triangle.svg": 11907,
	"./unverified-icon.svg": 53404,
	"./updated.svg": 37004,
	"./upgrade-premium-yellow.svg": 41910,
	"./upload-banner-icon.svg": 98183,
	"./upload-group-icon.svg": 19196,
	"./upload-icon.svg": 71722,
	"./upload-image-icon.svg": 53206,
	"./upload-image.svg": 65700,
	"./upload-img.svg": 5322,
	"./uploaded-image.svg": 2947,
	"./user-build-profile.svg": 42209,
	"./user-icon.svg": 7604,
	"./user-identification-1.svg": 18671,
	"./user-identification-2.svg": 55996,
	"./user-identification-3.svg": 10269,
	"./user-identification-arrow-right.svg": 41904,
	"./user-plus.svg": 9171,
	"./user-refer-and-earn.svg": 46958,
	"./user-tie.svg": 59175,
	"./user.svg": 10698,
	"./utility-icon.svg": 76357,
	"./ventilation.svg": 37524,
	"./verified-icon.svg": 13383,
	"./verified.svg": 25523,
	"./verifying.svg": 51200,
	"./video-consult-icon.svg": 31787,
	"./video-filter.svg": 28555,
	"./video-icon.svg": 84370,
	"./view-icon.svg": 25342,
	"./view-image-icon.svg": 794,
	"./view-members-icon.svg": 40268,
	"./view-note-icon.svg": 59170,
	"./visa-icon.svg": 48718,
	"./volume-high.svg": 30297,
	"./wallet-card-circle-bg-1.svg": 35598,
	"./wallet-card-circle-bg-2.svg": 29965,
	"./wallet-card-circle-bg-3.svg": 94508,
	"./wallet-card-circle-bg.svg": 27168,
	"./wallet-card-logo.svg": 37545,
	"./wallet-find-a-project.svg": 64438,
	"./wallet.svg": 56736,
	"./walls.svg": 13786,
	"./warning-icon.svg": 12517,
	"./warning-red-icon.svg": 29319,
	"./warranty-insurance-icon.svg": 45994,
	"./watch.svg": 63708,
	"./white-check.svg": 41533,
	"./white-exclaimation.svg": 71091,
	"./white-filled-estimates-icon.svg": 38869,
	"./white-filled-home-icon.svg": 8549,
	"./white-filled-in-progress-icon.svg": 82779,
	"./white-person.svg": 31512,
	"./white-watch.svg": 30016,
	"./windows.svg": 11986,
	"./windowsChart.svg": 17766,
	"./windowsIcon.svg": 85185,
	"./withdraw-icon.svg": 19541,
	"./workspace-logo-two.svg": 42075,
	"./workspace-logo.svg": 64798,
	"./workspace.svg": 92478,
	"./x.svg": 99897,
	"./yellow-building-filled-icon.svg": 38649,
	"./yellow-calendar-icon.svg": 24076,
	"./yellow-certificate-icon.svg": 4393,
	"./yellow-domain-icon.svg": 53870,
	"./yellow-duration-icon.svg": 86674,
	"./yellow-edit-icon.svg": 29718,
	"./yellow-filled-not-started-icon.svg": 470,
	"./yellow-location-icon.svg": 73689,
	"./yellow-mic-icon.svg": 28637,
	"./yellow-share-avatar-icon.svg": 33813,
	"./yellow-share-icon.svg": 88621,
	"./yellow-shield-icon.svg": 4903,
	"./yellow-success-icon.svg": 28277,
	"./yellow-trash-icon.svg": 75600,
	"./yellow-watch.svg": 62249,
	"./zoom.svg": 42226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;